module.exports = __webpack_public_path__ + "./docs/img/big-icon-member.129b7a460038072e5541be3bb54f56e0.svg";